import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  type: "button",
  class: "btn btn-primary btn-lg"
}

import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { useAdminEditWorkspacePage } from '@Organizations/Workspaces/pages-core'
    import AdminNavigationV2 from "@common/AdminNavigationV2.vue";
    import ValidationError from '@common/Components/ValidationError.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminEditWorkspacePage',
  setup(__props) {

    const route = useRoute()
    const id = computed(() => String(route.params.id))

    const name = ref()
    const description = ref()
    const startupUrl = ref()

    const { useWorkspaceDetailsQuery, useUpdateWorkspaceCommand, useDeleteWorkspaceCommand } = useAdminEditWorkspacePage()

    const { modelWorkspaceDetailsQueryV1, runWorkspaceDetailsQueryV1 } = useWorkspaceDetailsQuery(id)
    const { invokeUpdateWorkspaceCommandV1, succeedUpdateWorkspaceCommandV1, invoking, validationErrors } = useUpdateWorkspaceCommand(id, name, description, startupUrl)
    const { invokeDeleteWorkspaceCommandV1, succeedDeleteWorkspaceCommandV1 } = useDeleteWorkspaceCommand(id)

    const tid = computed(() => modelWorkspaceDetailsQueryV1.value?.OrganizationUnitId)
    const originalName = computed(() => modelWorkspaceDetailsQueryV1.value?.Name)

    function handleDeleteWorkspaceCommandV1() {
        if (confirm(`Do you want to delete '${originalName.value}' workspace?`)) {
            invokeDeleteWorkspaceCommandV1()
        }
    }

    onMounted(() => {
        runWorkspaceDetailsQueryV1()
    })

    watch(modelWorkspaceDetailsQueryV1, () =>
    {
        name.value = modelWorkspaceDetailsQueryV1.value?.Name
        description.value = modelWorkspaceDetailsQueryV1.value?.Description
        startupUrl.value = modelWorkspaceDetailsQueryV1.value?.StartupUrl
    })

    watch(name, () => {
        document.title = name.value
    })

    watch(succeedUpdateWorkspaceCommandV1, succeed => {
        if (succeed) {
            location.href = `/#/admin/organizations/workspaces/manage/${id.value}`
        }
    })

    watch(succeedDeleteWorkspaceCommandV1, succeed => {
        if (succeed) {
            location.href = `/#/admin/organizations/workspaces/${tid.value}`
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(name.value), 1 /* TEXT */),
          _createElementVNode("a", {
            href: `/#/admin/organizations/workspaces/manage/${id.value}`,
            class: "btn btn-link btn-sm"
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_6),
          _createElementVNode("button", {
            onClick: handleDeleteWorkspaceCommandV1,
            class: "btn btn-link btn-sm"
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", {
              class: "fa fa-remove",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Delete this workspace ", -1 /* CACHED */)
          ]))])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "Name" }, "Name:", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
          type: "text",
          class: "form-control",
          placeholder: "Name of workspace"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, name.value]
        ]),
        _createVNode(ValidationError, {
          context: "Name",
          errors: _unref(validationErrors)
        }, null, 8 /* PROPS */, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "Description" }, "Description:", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
          class: "form-control",
          placeholder: "Description of workspace"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, description.value]
        ]),
        _createVNode(ValidationError, {
          context: "Description",
          errors: _unref(validationErrors)
        }, null, 8 /* PROPS */, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { for: "StartupUrl" }, "Startup url:", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startupUrl).value = $event)),
          type: "text",
          class: "form-control",
          placeholder: "Startup url - only for advanced scenarios"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, startupUrl.value]
        ]),
        _createVNode(ValidationError, {
          context: "StartupUrl",
          errors: _unref(validationErrors)
        }, null, 8 /* PROPS */, ["errors"])
      ]),
      _withDirectives(_createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(invokeUpdateWorkspaceCommandV1) && _unref(invokeUpdateWorkspaceCommandV1)(...args))),
        type: "button",
        class: "btn btn-primary btn-lg"
      }, "Update", 512 /* NEED_PATCH */), [
        [_vShow, !_unref(invoking)]
      ]),
      _withDirectives(_createElementVNode("button", _hoisted_11, "Updating...", 512 /* NEED_PATCH */), [
        [_vShow, _unref(invoking)]
      ])
    ])
  ]))
}
}

})